import { useState, useEffect } from "react"
import "./BookOfBusinessForm.css"

import { Radio } from "antd"
import BobListField from "./BobListField"
import { useSaveBobFormMutation, useGetBobFormMutation } from "./bobApiSlice"

import { selectCurrentId } from "../auth/authSlice"
import { useSelector, useDispatch } from "react-redux"
import { showSpinner, hideSpinner } from "../../components/componentSlice"
import { selectCrm } from "../crm/crmSlice"
import { useNavigate } from "react-router-dom"

const BookOfBusinessForm = () => {
    const advisorId = useSelector(selectCurrentId)
    const crm = useSelector(selectCrm)

    const [bobBasicDetails, setBobBasicDetails] = useState(null)
    const [clientCompany, setClientCompany] = useState({"isApplicable": true, "values": [null]})
    const [clientFinra, setClientFinra] = useState({"isApplicable": true, "values": [null]})
    const [clientPoa, setClientPoa] = useState({"isApplicable": true, "values": [null]})
    const [obtainTrustedContactInfo, setObtainTrustedContactInfo] = useState(true)
    const [accountMargin, setAccountMargin] = useState({"isApplicable": true, "values": [null]})
    const [accountOption, setAccountOption] = useState({"isApplicable": true, "values": [null]})
    const [accountCollaterizedLoad, setAccountCollaterizedLoad] = useState({"isApplicable": true, "values": [null]})
    const [accountCorporateTrustee, setAccountCorporateTrustee] = useState({"isApplicable": true, "values": [null]})
    const [accountIncomeNeeds, setAccountIncomeNeeds] = useState({"isApplicable": true, "values": [null]})
    const [clientNonUsCitizen, setClientNonUsCitizen] = useState({"isApplicable": true, "values": [null]})
    const [beneficiaryNonUsCitizen, setBeneficiaryNonUsCitizen] = useState({"isApplicable": true, "values": [null]})
    const [surrenderCharges, setSurrenderCharges] = useState({"managedAccounts": null, "brokerageAccounts": null})
    
    const [errorMessage, setErrorMessage] = useState(null)

    const [saveBobForm, {isLoading: isSaveBobFormLoading}] = useSaveBobFormMutation()
    const [getBobForm, {isLoading: isGetBobFormLoading}] = useGetBobFormMutation()

    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if(isSaveBobFormLoading || isGetBobFormLoading) {
            dispatch(showSpinner())
        } else{
            dispatch(hideSpinner())
        }
    }, [isSaveBobFormLoading, isGetBobFormLoading])

    useEffect(() => {
        const handleGetForm = async () => {
            try {
                let response = await getBobForm(advisorId).unwrap()
                if(response) {
                    mapResponse(response)
                }
            } catch(err) {
                if(!err.status || err.status === "FETCH_ERROR") {
                    setErrorMessage("No Server Response")
                } else {
                    setErrorMessage(err.data?.detail)
                }
            }
        }

        if(advisorId) {
            handleGetForm()
        }
    }, [advisorId])

    const mapResponse = (response) => {
        setBobBasicDetails(response.bobBasicDetails)
        setClientCompany(response.clientCompany)
        setClientFinra(response.clientFinra)
        setClientPoa(response.clientPoa)
        setObtainTrustedContactInfo(response.obtainTrustedContactInfo)
        setAccountMargin(response.accountMargin)
        setAccountOption(response.accountOption)
        setAccountCollaterizedLoad(response.accountCollaterizedLoad)
        setAccountCorporateTrustee(response.accountCorporateTrustee)
        setAccountIncomeNeeds(response.accountIncomeNeeds)
        setClientNonUsCitizen(response.clientNonUsCitizen)
        setBeneficiaryNonUsCitizen(response.beneficiaryNonUsCitizen)
        setSurrenderCharges(response.surrenderCharges)
    }

    const onSubmit = async (e) => {
        e.preventDefault()

        let request = {
            advisorId,
            bobBasicDetails,
            clientCompany,
            clientFinra,
            clientPoa,
            obtainTrustedContactInfo,
            accountMargin,
            accountOption,
            accountCollaterizedLoad,
            accountCorporateTrustee,
            accountIncomeNeeds,
            clientNonUsCitizen,
            beneficiaryNonUsCitizen,
            surrenderCharges
        }

         try {
            let response = await saveBobForm(request).unwrap()
            if(response?.id) {
                navigateAfterSubmit()
            }
            
        } catch(err) {
            if(!err.status || err.status === "FETCH_ERROR") {
                setErrorMessage("No Server Response")
            } else {
                setErrorMessage(err.data?.detail)
            }
        }
    }

    const navigateAfterSubmit = async () => {
        try {
            if(crm) {
                navigate(`/dash/crm/${crm}`)
            } else {
                navigate(`/dash/crm/${0}`)
            }
        } catch (err) {
            if(err.status == 403) {
                navigate("/dash/error403")
            } else {
                navigate(`/dash/crm/${0}`)
            }
        }
    }

    const handleBasicDetailsChange = (e) => {
        setBobBasicDetails(prev => ({...prev, [e.name] : e.value}))
    }

    const handleSurrenderChargesChange = (e) => {
        setSurrenderCharges(prev => ({...prev, [e.name] : e.value}))
    }

    return (
        <div className="bob-container">
            <div className="bob-card">
                <div className='top-header'>
                    <header>Book Of Business Questions</header>
                </div>
                <form className="bob-form" onSubmit={(e) => onSubmit(e)}>
                    <div className="form-group">
                        <label for="name">Name</label>
                        <input className="inpt" type="name" id="name" name="name" required value={bobBasicDetails?.name} onChange={(e) => handleBasicDetailsChange(e.target)} />
                    </div>

                    <div className="form-group">
                        <label for="branchAddress">Branch Address</label>
                        <input className="inpt" type="branchAddress" id="branchAddress" name="branchAddress" required value={bobBasicDetails?.branchAddress} onChange={(e) => handleBasicDetailsChange(e.target)} />
                    </div>

                    <div className="form-group">
                        <label for="phone">Phone</label>
                        <input className="inpt" type="phone" id="phone" name="phone" required value={bobBasicDetails?.phone} onChange={(e) => handleBasicDetailsChange(e.target)} />
                    </div>

                    <div className="form-group">
                        <label for="postTransitionEmail">Post-Transition Email</label>
                        <input className="inpt" type="postTransitionEmail" id="postTransitionEmail" name="postTransitionEmail" required value={bobBasicDetails?.postTransitionEmail} onChange={(e) => handleBasicDetailsChange(e.target)} />
                    </div>

                    <div className="form-group">
                        <label for="contraBd">Contra B/D</label>
                        <input className="inpt" type="contraBd" id="contraBd" name="contraBd" required value={bobBasicDetails?.contraBd} onChange={(e) => handleBasicDetailsChange(e.target)} />
                    </div>

                    <div className="form-group">
                        <label for="affiliatingBd">Affiliating B/D</label>
                        <input className="inpt" type="affiliatingBd" id="affiliatingBd" name="affiliatingBd" required value={bobBasicDetails?.affiliatingBd} onChange={(e) => handleBasicDetailsChange(e.target)} />
                    </div>

                    <BobListField 
                        fieldDesc={"List any clients who are, or have an immediate family member, who is a senior officer, director, or large shareholder in a public company, and list the company."}
                        fieldValue={clientCompany}
                        updateFieldValue={setClientCompany}
                    />

                    <BobListField 
                        fieldDesc={"List any clients who are, or have an immediate family member, employed by your broker dealer or another member of FINRA or a stock exchange."}
                        fieldValue={clientFinra}
                        updateFieldValue={setClientFinra}
                    />

                    <BobListField 
                        fieldDesc={"List any client who will be signing with a POA."}
                        fieldValue={clientPoa}
                        updateFieldValue={setClientPoa}
                    />

                    <div className="form-group">
                        <label for="nonCompeteIssues">Do you want to obtain trusted contact information during the transition?</label>
                        <Radio.Group
                            style={{ display: 'flex', gap: 16, paddingBlockStart: 5, paddingLeft: 5 }}
                            onChange={(e) => setObtainTrustedContactInfo((prev) => !prev)}
                            options={[
                                { label: 'Yes', value: true }, 
                                { label: 'No', value: false }
                            ]}
                            defaultValue={true}
                        />
                    </div>

                    <BobListField 
                        fieldDesc={"List any accounts using margin."}
                        fieldValue={accountMargin}
                        updateFieldValue={setAccountMargin}
                    />

                    <BobListField 
                        fieldDesc={"List any accounts using options."}
                        fieldValue={accountOption}
                        updateFieldValue={setAccountOption}
                    />

                    <BobListField 
                        fieldDesc={"List any accounts that have a collateralized loan."}
                        fieldValue={accountCollaterizedLoad}
                        updateFieldValue={setAccountCollaterizedLoad}
                    />

                    <BobListField 
                        fieldDesc={"List any accounts with a corporate trustee."}
                        fieldValue={accountCorporateTrustee}
                        updateFieldValue={setAccountCorporateTrustee}
                    />

                    <BobListField 
                        fieldDesc={"List any accounts with immediate income needs."}
                        fieldValue={accountIncomeNeeds}
                        updateFieldValue={setAccountIncomeNeeds}
                    />

                    <BobListField 
                        fieldDesc={"Do you have any clients that are not US Citizens? If yes, please the client and the citizenship."}
                        fieldValue={clientNonUsCitizen}
                        updateFieldValue={setClientNonUsCitizen}
                    />

                    <BobListField 
                        fieldDesc={"Any beneficiaries that are not US citizens? If yes, please list client and beneficiary."}
                        fieldValue={beneficiaryNonUsCitizen}
                        updateFieldValue={setBeneficiaryNonUsCitizen}
                    />

                    <div className="ras-card">
                        <div className="ras-card-header">
                            <h4>Surrender Charges</h4>
                        </div>
                        <div className="ras-card-body">
                            <div className="form-group">
                                <label for="managedAccounts">Managed Accounts $</label>
                                <input className="inpt" type="managedAccounts" id="managedAccounts" name="managedAccounts" required value={surrenderCharges.managedAccounts} onChange={(e) => handleSurrenderChargesChange(e.target)} />
                            </div>

                            <div className="form-group">
                                <label for="brokerageAccounts">Brokerage Accounts $</label>
                                <input className="inpt" type="brokerageAccounts" id="brokerageAccounts" name="brokerageAccounts" required value={surrenderCharges.brokerageAccounts} onChange={(e) => handleSurrenderChargesChange(e.target)} />
                            </div>
                        </div>
                    </div>

                    <div className="form-group">
                        <button className="crm-button">Submit</button>
                    </div>

                    
                </form>
            </div>

        </div>
    )
}

export default BookOfBusinessForm